import { getLocaleStore } from '@/i18n';
import { BrushTagType } from '../config';

export function getTagConfig() {
    const { $t } = getLocaleStore();
    return [
        {
            type: BrushTagType.all,
            name: $t((v) => v.collapse.brushCollapse.all),
        },
        {
            type: BrushTagType.line,
            name: $t((v) => v.collapse.brushCollapse.linePen),
        },

        {
            type: BrushTagType.shape,
            name: $t((v) => v.collapse.brushCollapse.shape),
        },
        {
            type: BrushTagType.markup,
            name: $t((v) => v.collapse.brushCollapse.markupPen),
        },
        {
            type: BrushTagType.curve,
            name: $t((v) => v.collapse.brushCollapse.curvePen),
        },
    ];
}
